<template>
  <DashboardLayout :breadcrumbs="breadcrumbs">
    <div class="container is-fluid">
      <h1 class="title is-5">{{ $t('routes.editDocflow') }}</h1>
      <div class="form-container">
        <DocflowAppealForm @save="save"
                             :edit-mode="true"
                             :document-data="documentData">
        </DocflowAppealForm>
      </div>
    </div>
  </DashboardLayout>
</template>

<script>
  import {mapState} from 'vuex'
  import DashboardLayout from '@/components/DashboardLayout'
  import DocflowAppealForm from '@/components/DocflowAppealForm'

  export default {
    components: {
      DashboardLayout,
      DocflowAppealForm
    },
    methods: {
      save(documentForm) {
        this.$store.dispatch('Docflow/update', {
          ...documentForm,
          category: 'appeals'
        }).then(document => {
          this.$router.push({
            name: 'docflowAppealDetail',
            params: {documentId: document.id}
          })
        })
      }
    },
    mounted() {
      this.$store.dispatch('Docflow/getRelations', {category: 'appeals', documentId: this.$route.params.documentId})
    },
    computed: {
      ...mapState('Docflow', ['document']),
      documentData() {
        return this.document ? {
          ...this.document,
          registered_date: this.document.registered_date ? new Date(this.document.registered_date) : null,
          term_date: this.document.term_date ? new Date(this.document.term_date) : null
        } : {}
      },
      breadcrumbs() {
        return [
          { name: 'docflow', path: 'docflow' },
          {
            name: 'docflowDetail',
            path: {
              name: 'docflowAppealDetail',
              params: {documentId: this.$route.params.documentId}
            }
          },
          { name: 'editDocflow' }
        ]
      }
    }
  }
</script>